
export default {
  props: {
    image: {
      type: Object,
      required: true,
    },
    controlsEnabled: {
      type: Boolean,
      default: false,
    },
    prevSlide: {
      type: Function,
      default: () => undefined,
    },
    nextSlide: {
      type: Function,
      default: () => undefined,
    },
    canNext: {
      type: Boolean,
      default: true,
    },
    canPrev: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    closeLightbox () {
      this.$emit(`close`);
    },
  },
};
